import { useState } from "react";
import { Badge, Popover, List, Button, Typography, Empty } from "antd";
import { BellOutlined, CheckOutlined } from "@ant-design/icons";
import { useNotifications } from "../hooks/useNotifications";

const { Text } = Typography;

const typeColor = {
  success: "#10b981",
  error:   "#ef4444",
  info:    "#4f46e5",
};

export default function NotificationBell({ role = "user" }) {
  const [open, setOpen] = useState(false);
  const { notifications, unreadCount, markAllRead } = useNotifications(role);

  const handleOpen = (visible) => {
    setOpen(visible);
    if (visible && unreadCount > 0) markAllRead();
  };

  const content = (
    <div style={{ width: 320 }}>
      <div style={{
        display: "flex", justifyContent: "space-between",
        alignItems: "center", marginBottom: 8,
      }}>
        <Text strong>Notifications</Text>
        {notifications.length > 0 && (
          <Button size="small" icon={<CheckOutlined />} onClick={markAllRead}>
            Mark all read
          </Button>
        )}
      </div>

      {notifications.length === 0 ? (
        <Empty description="No notifications" imageStyle={{ height: 40 }} />
      ) : (
        <List
          dataSource={notifications}
          style={{ maxHeight: 360, overflowY: "auto" }}
          renderItem={(n) => (
            <List.Item style={{
              padding: "8px 4px",
              background: n.read ? "transparent" : "#f5f3ff",
              borderRadius: 8,
              marginBottom: 4,
            }}>
              <div style={{ display: "flex", gap: 10, alignItems: "flex-start" }}>
                <div style={{
                  width: 8, height: 8, borderRadius: "50%", marginTop: 6, flexShrink: 0,
                  background: typeColor[n.type] ?? "#6b7280",
                }} />
                <div>
                  <Text style={{ fontSize: 13 }}>{n.message}</Text>
                  <div>
                    <Text type="secondary" style={{ fontSize: 11 }}>
                      {new Date(n.createdAt).toLocaleTimeString()}
                    </Text>
                  </div>
                </div>
              </div>
            </List.Item>
          )}
        />
      )}
    </div>
  );

  return (
    <Popover
      content={content}
      trigger="click"
      open={open}
      onOpenChange={handleOpen}
      placement="bottomRight"
    >
      <Badge count={unreadCount} size="small">
        <Button
          type="text"
          icon={<BellOutlined style={{ fontSize: 20 }} />}
          style={{ display: "flex", alignItems: "center" }}
        />
      </Badge>
    </Popover>
  );
}